export enum NcDpiMonthlyFileTypes {
	PDR = 'Payroll Detail Record',
	PSR = 'Payroll Summary Record',
	MFR = 'Monthly Financial Record',
	GER = 'General Expense Record',
}
